import React from "react";
import ServiceWhyHead from "./ServiceWhyHead";
import ServiceWhyMain from "./ServiceWhyMain";
import "./ServiceWhy.css";


const ServiceWhy = () => {
  return (
    <div className="serviceWhyContainer">
      <ServiceWhyHead />
      <ServiceWhyMain />
    </div>
  );
};

export default ServiceWhy;
